import { render, staticRenderFns } from "./billTab.vue?vue&type=template&id=8b250258&scoped=true&"
import script from "./billTab.vue?vue&type=script&lang=js&"
export * from "./billTab.vue?vue&type=script&lang=js&"
import style0 from "./billTab.vue?vue&type=style&index=0&id=8b250258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b250258",
  null
  
)

export default component.exports